import { alpha } from '@mui/material';
/**
 * Red colors by number from the lightest to the darkest
 */
export var red01 = '#ff758a';
export var red02 = '#f82847';
export var red03 = '#db0021';
export var red04 = '#8c0015';
export var red02opacity20 = alpha(red02, 0.2);
